/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AgencyPoliciesFilterOptionsEnum {
    CURRENT_ACTIVE = 1,
    NEW_SUBMISSIONS = 2,
    PENDING_RENEWALS = 3,
    WAITING_INFORMATION = 4,
    BOUND_FUTURE = 5,
    CUSTOM_DATES = 6,
    AUDITED = 7,
    EXPIRED = 8,
    LOST_AND_DECLINED = 9,
    CANCELLED = 10,
    PENDING_CANCELLATION = 11,
}
